import { ResetPasswordWrapper } from "./styled"
import Button from "components/Button"
import Input from "components/Input"
import { Link, useNavigate, useLocation } from "react-router-dom"
import ShowToast from "utils/ShowToast"
import { useFormik } from "formik"
import * as Yup from "yup"
import { REGEX_PASSWORD } from "constants/regex"
import { authError } from "errors/auth"
import { useEffect } from "react"
import { resetPasswordApi } from "services/authServices"
import { appURL } from "utils/index"

const ResetPassword = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const token = query.get("token")
    const email = query.get("email")
    const formData = useFormik({
        initialValues: {
            password: "",
            password_confirm: ""
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            password: Yup.string().trim().required(authError.requiredPassword).matches(REGEX_PASSWORD, authError.invalidPassword),
            password_confirm: Yup.string().trim().required(authError.requiredPasswordConfirm).oneOf(
                [Yup.ref("password"), null],
                authError.invalidPasswordConfirm
            )
        }),
        onSubmit: (values, { setFieldError }) => {
            values.email = email
            values.app_url = appURL
            const api = async () => {
                const request = await resetPasswordApi(token, values)
                if (request.status === 200) {
                    const response = request.data
                    if (response.success === true) {
                        navigate("/login")
                        ShowToast('success', 'Bạn đã đổi thành công mật khẩu!')
                    }
                    else {
                        ShowToast("error", "Đặt lại mật khẩu thất bại, vui lòng kiểm tra chính xác đường dẫn email của bạn")
                    }
                }
                else {
                    ShowToast("error", "Đặt lại mật khẩu thất bại, vui lòng kiểm tra chính xác đường dẫn email của bạn")
                }
            }
            api()
        }
    })

    useEffect(() => {
        if (!token && !email && token === "" && email === "")
            navigate("/")
    }, [email, navigate, token])

    return (
        <ResetPasswordWrapper className="flex-center pt-35">
            <form onSubmit={formData.handleSubmit}>
                <h1 className="text-black s-24 bold text-center mb-50">ĐẶT LẠI MẬT KHẨU</h1>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Mật khẩu"
                        name="password"
                        type="password"
                        value={formData.values.password}
                        isError={!!formData.errors.password}
                        message={formData.errors.password}
                        onChange={formData.handleChange}
                    />
                </div>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Xác nhận mật khẩu"
                        type="password"
                        name="password_confirm"
                        value={formData.values.password_confirm}
                        isError={!!formData.errors.password_confirm}
                        message={formData.errors.password_confirm}
                        onChange={formData.handleChange}
                    />
                </div>

                <Button className="action-danger-1 btn-reset" type="submit">Đặt mật khẩu</Button>
                <div className="mt-25 flex-space">
                    <Link to="/forgot-password" className="text-link s-16 text-link-hover ">Trở về quên mật khẩu</Link>
                    <Link to="/login" className="text-link s-16 text-link-hover ">Trở về đăng nhập</Link>
                </div>
            </form>
        </ResetPasswordWrapper>
    )
}

export default ResetPassword